export enum SendStatus {
  Sending,
  Draft,
  Finish,
  FinishNewsletter,
}
